import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';
import { TimerField, FeedbackField, CsvQuestionsPicker } from '../../components/qcm/QcmShared';

// Créer un QCM dans un sujet à partir d'un fichier CSV
export default function AdminQcmImport() {
  const { id: subjectId } = useParams();
  const { authFetch } = useAuth();
  const navigate = useNavigate();
  const [subject, setSubject] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', timer_enabled: false, timer_minutes: 10, feedback_mode: 'end', published: true });
  const [flash, setFlash] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    authFetch(`/api/admin/qcm/subjects/${subjectId}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setSubject)
      .catch(() => setFlash({ type: 'error', text: 'Sujet introuvable' }));
    // eslint-disable-next-line
  }, [subjectId]);

  const set = (patch) => setForm(prev => ({ ...prev, ...patch }));

  const onReady = (qs, fileName) => {
    setQuestions(qs);
    // Titre proposé à partir du nom du fichier, si le champ est encore vide
    if (fileName && !form.title) {
      set({ title: fileName.replace(/\.csv$/i, '').replace(/[_-]+/g, ' ').trim() });
    }
  };

  const create = async (e) => {
    e.preventDefault();
    if (questions.length === 0) {
      setFlash({ type: 'error', text: 'Choisissez un fichier CSV contenant au moins une question valide.' });
      return;
    }
    setSaving(true); setFlash(null);
    try {
      const r = await authFetch('/api/admin/qcm/quizzes', {
        method: 'POST',
        body: JSON.stringify({ ...form, subject_id: Number(subjectId), questions })
      });
      if (!r.ok) throw new Error(await errorMessage(r));
      const d = await r.json();
      navigate(`/admin/qcm/${d.id}?importe=${questions.length}`);
    } catch (err) {
      setFlash({ type: 'error', text: `QCM non créé : ${err.message}` });
      setSaving(false);
    }
  };

  return (
    <div>
      <Link to={`/admin/qcm/sujets/${subjectId}`} className="qcm-back">← {subject ? subject.name : 'retour au sujet'}</Link>
      <h1 style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>Importer un QCM depuis un CSV</h1>
      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}

      <form onSubmit={create}>
        <div className="qcm-panel">
          <CsvQuestionsPicker onReady={onReady} />
        </div>

        <div className="qcm-panel">
          <div className="form-group">
            <label>Titre du QCM</label>
            <input value={form.title} onChange={e => set({ title: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Description (facultative)</label>
            <input value={form.description} onChange={e => set({ description: e.target.value })} />
          </div>
          <TimerField enabled={form.timer_enabled} minutes={form.timer_minutes} onChange={set} />
          <FeedbackField value={form.feedback_mode} onChange={set} />
          <div className="form-group">
            <label>
              <input type="checkbox" checked={form.published} onChange={e => set({ published: e.target.checked })} /> Publier tout de suite
            </label>
            <p className="qcm-help">Décochez pour créer le QCM en brouillon : il ne sera pas visible sur le site tant que vous ne l'aurez pas publié.</p>
          </div>
        </div>

        <button className="btn" type="submit" disabled={saving || questions.length === 0}>
          {saving ? 'création…' : `créer le QCM${questions.length ? ` (${questions.length} questions)` : ''}`}
        </button>
      </form>
    </div>
  );
}
